module.exports = __webpack_public_path__ + "img/filter-funnel-01.5690f99f.svg";